define(["require", "exports", "tslib", "@arcgis/core/geometry/Point", "@arcgis/core/geometry/Polygon", "@arcgis/core/geometry/Polyline", "./GeometryFactory", "./GeometryUtil"], function (require, exports, tslib_1, Point_1, Polygon_1, Polyline_1, GeometryFactory_1, GeometryUtil_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.parseChangeEvent = exports.prettyEntityRefId = exports.toInt = exports.toFloat = exports.mergePolygon = exports.mergePolyline = exports.mergePoint = exports.getGraphicAttribute = exports.id = void 0;
    Point_1 = tslib_1.__importDefault(Point_1);
    Polygon_1 = tslib_1.__importDefault(Polygon_1);
    Polyline_1 = tslib_1.__importDefault(Polyline_1);
    const MAX_ENTITY_INT_VALUE = 2147483647;
    function id() {
        return Math.round(Math.random() * MAX_ENTITY_INT_VALUE);
    }
    exports.id = id;
    function getGraphicAttribute(g, key) {
        if (g && g.attributes) {
            for (let k of Object.keys(g.attributes)) {
                if (k.toLowerCase() == key.toLowerCase()) {
                    return g.attributes[k];
                }
            }
        }
        return null;
    }
    exports.getGraphicAttribute = getGraphicAttribute;
    function mergePoint(a, b) {
        if (!(b instanceof Point_1.default)) {
            b = GeometryFactory_1.GeometryFactory.toPoint(b);
        }
        if (!a || !GeometryUtil_1.GeometryUtil.areEqual(a, b)) {
            a = b;
        }
        return a;
    }
    exports.mergePoint = mergePoint;
    function mergePolyline(a, b) {
        if (!(b instanceof Polyline_1.default)) {
            b = GeometryFactory_1.GeometryFactory.toPolyline(b.paths);
        }
        if (!a || !GeometryUtil_1.GeometryUtil.areEqual(a, b)) {
            a = b;
        }
        return a;
    }
    exports.mergePolyline = mergePolyline;
    function mergePolygon(a, b) {
        if (!(b instanceof Polygon_1.default)) {
            b = GeometryFactory_1.GeometryFactory.toPolygon(b.rings);
        }
        if (!a || !GeometryUtil_1.GeometryUtil.areEqual(a, b)) {
            a = b;
        }
        return a;
    }
    exports.mergePolygon = mergePolygon;
    function toFloat(x) {
        return !isNaN(x) ? parseFloat(x) : x;
    }
    exports.toFloat = toFloat;
    function toInt(x) {
        return !isNaN(x) ? parseInt(x) : x;
    }
    exports.toInt = toInt;
    function prettyEntityRefId(refId) {
        const firstSpaceChar = refId.indexOf(" ");
        if (firstSpaceChar > -1) {
            refId = refId.substr(0, firstSpaceChar);
        }
        if (refId.length > 7) {
            refId = refId.substr(0, 7) + "..";
        }
        return refId;
    }
    exports.prettyEntityRefId = prettyEntityRefId;
    function parseChangeEvent(change) {
        const changed = change.name.toString();
        const oldVal = change.type == "update" ? change.oldValue : null;
        const newVal = change.type == "add" || change.type == "update" ? change.newValue : null;
        console.log({ changed, oldVal, newVal });
        return { changed, oldVal, newVal };
    }
    exports.parseChangeEvent = parseChangeEvent;
});
